import React, { useRef, useState } from 'react';
import { Box, Grid, Typography } from '@mui/material';
import { AddIcon } from 'icons/materialIcons';
import TeamDarkButtonWithIcon from 'team/shared/components/button/TeamDarkButtonWithIcon';
import AddTemplateModal from './AddTemplateModal';
import SelectCardModal from './SelectCardModal';

const TeamTemplateNavbar = ({ templatesCount, onCreateTemplate, team }) => {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [cardModalOpen, setCardModalOpen] = useState(false);
    const buttonRef = useRef(null);

    const handleAddClick = () => {
        setIsModalOpen(true);
    };

    const handleModalClose = () => {
        setIsModalOpen(false);
    };

    const handleSelect = (type, card) => {
        if (type === 'open-card-modal') {
            setIsModalOpen(false);
            // Small delay to ensure first modal closes before opening second
            setTimeout(() => {
                setCardModalOpen(true);
            }, 100);
        } else {
        setIsModalOpen(false);
            onCreateTemplate(type, card);
        }
    };

    const handleCardSelect = (card) => {
        setCardModalOpen(false);
        onCreateTemplate('from-card', card);
    };

    const handleCardModalClose = () => {
        setCardModalOpen(false);
    };

    return (
        <>
            <Box sx={{ padding: '1rem' }}>
                <Grid container spacing={2} alignItems="center" sx={{ marginBottom: '1rem' }}>
                    {/* Left Side - Title */}
                    <Grid item xs={12} sm="auto">
                        <Typography variant="h6" sx={{ fontWeight: 500 }}>
                            Templates{' '}
                            <Typography component="span" variant="body2" sx={{ fontWeight: 400, color: '#757575' }}>
                                ({templatesCount})
                            </Typography>
                        </Typography>
                    </Grid>

                    {/* Right Side - Action Button */}
                    <Grid item xs={12} sm container justifyContent="flex-end">
                        <Grid container spacing={1} justifyContent="flex-end">
                            {/* Add Template Button (Dark) */}
                            <Grid item>
                                <div ref={buttonRef}>
                                    <TeamDarkButtonWithIcon
                                        text="Add Template"
                                        icon={<AddIcon />}
                                        onClick={handleAddClick}
                                        iconPosition="start"
                                    />
                                </div>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </Box>

            <AddTemplateModal
                isOpen={isModalOpen}
                onClose={handleModalClose}
                onSelect={handleSelect}
                anchorEl={buttonRef.current}
                offset={10}
                horizontalOffset={0}
            />

            {/* Card Selection Modal */}
            <SelectCardModal
                open={cardModalOpen}
                onClose={handleCardModalClose}
                onSelectCard={handleCardSelect}
                anchorEl={buttonRef.current}
                teamId={team?._id || team?.id}
            />
        </>
    );
};

export default TeamTemplateNavbar;

